import React, { FC, PropsWithChildren } from 'react';
import { useGetAppContextSubscription } from 'queries/AppContextSubscription/appContextSubscription.queries';
import { LoadingPage } from '../Loading';
import ServerError from 'components/pages/Errors/ServerError';

export const AppContextProvider: FC<PropsWithChildren> = ({ children }) => {
    const { isFetching, isError } = useGetAppContextSubscription();

    if (isError) {
        return <div className="d-flex flex-column justify-content-center vh-100">
            <ServerError />
        </div>;
    }

    if (isFetching) {
        return <LoadingPage />;
    }

    return children;
};
